import { render, staticRenderFns } from "./TeamLeader.vue?vue&type=template&id=c4020a86&scoped=true&"
import script from "./TeamLeader.vue?vue&type=script&lang=js&"
export * from "./TeamLeader.vue?vue&type=script&lang=js&"
import style0 from "./TeamLeader.vue?vue&type=style&index=0&id=c4020a86&lang=scss&scoped=true&"
import style1 from "./TeamLeader.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4020a86",
  null
  
)

export default component.exports